/**
 * French (Canada) locale for messaging-ui.
 * Export is the "messaging" subtree for host i18n merge.
 */
import type { MessagingLocale } from './en'

export const messagingFrCa = {
  list: {
    loading: `Chargement des groupes de messagerie...`,
    error: `Erreur`,
    empty: `Aucun groupe de messagerie trouvé`,
    emptyDescription: `Il n'y a actuellement aucun groupe de messagerie configuré pour ce PBX.`,
    deleteConfirmTitle: `Supprimer le groupe de messagerie`,
    deleteConfirm: `Êtes-vous sûr de vouloir supprimer « {{name}} »?`,
    smsEnabled: `Activé`,
    smsDisabled: `Désactivé`,
    delete: `Supprimer`,
    columnGroupName: `Nom du groupe`,
    columnPrimarySms: `SMS principal`,
    columnMembers: `Membres`,
    columnSmsStatus: `État SMS`,
    columnCreated: `Créé`,
    columnUpdated: `Mis à jour`,
    columnActions: `Actions`,
    toast: {
      createdTitle: `Groupe de messagerie créé`,
      createdDescription: `« {{name}} » a été créé avec succès.`,
      createFailedTitle: `Échec de la création`,
      createFailedDescription: `Impossible de créer le groupe de messagerie`,
      deletedTitle: `Groupe de messagerie supprimé`,
      deletedDescription: `« {{name}} » a été supprimé.`,
      deleteFailedTitle: `Échec de la suppression`,
      deleteFailedDescription: `Impossible de supprimer le groupe de messagerie`,
    },
    title: `Messagerie`,
    createButton: `+ Créer un groupe`,
    searchPlaceholder: `Rechercher par nom ou numéro de téléphone...`,
    noResults: `Aucun résultat`,
    noResultsDescription: `Aucun groupe de messages ne correspond à « {{search}} ».`,
    noMembersWarning: `Ce groupe n'a aucun membre. Les messages des clients pourraient ne pas être lus.`,
  },
  detail: {
    validationErrorTitle: `Erreur de validation`,
    validationErrorDescription: `Le nom du groupe est obligatoire`,
    toast: {
      updatedTitle: `Groupe de messagerie mis à jour`,
      updateFailedTitle: `Échec de la mise à jour`,
      updateFailedDescription: `Impossible de mettre à jour le groupe de messagerie`,
      smsAddedTitle: `Numéro SMS ajouté`,
      smsAddFailedTitle: `Impossible d'ajouter le numéro SMS`,
      smsRemovedTitle: `Numéro SMS supprimé`,
      smsRemoveFailedTitle: `Impossible de supprimer le numéro SMS`,
      memberAddedTitle: `Membre ajouté`,
      memberAddFailedTitle: `Impossible d'ajouter le membre`,
      memberAddFailedDescription: `Impossible d'ajouter le membre au groupe`,
      memberRemovedTitle: `Membre supprimé`,
      memberRemoveFailedTitle: `Impossible de supprimer le membre`,
    },
    loading: `Chargement du groupe de messagerie...`,
    error: `Erreur`,
    notFound: `Groupe de messagerie introuvable.`,
    title: `Modifier le groupe de messagerie`,
    viewTitle: `Groupe de messagerie`,
    groupNameLabel: `Nom du groupe`,
    groupNamePlaceholder: `Entrez le nom du groupe`,
    primarySmsLabel: `Numéro SMS principal`,
    primarySmsPlaceholder: `Sélectionnez le numéro SMS principal`,
    campaignIdWarning: `Le numéro sélectionné n'a pas d'ID de campagne et pourrait ne pas pouvoir envoyer de SMS, sauf s'il s'agit d'un service sans frais ou d'un numéro canadien.`,
    associatedSmsLabel: `Numéros SMS secondaires`,
    noCampaignId: `(Aucun ID de campagne)`,
    removeSmsAria: `Supprimer le numéro SMS`,
    addSmsNumberAria: `Ajouter un numéro SMS`,
    unsavedChanges: `Modifications non enregistrées`,
    campaignSummaryTitle: `{{count}} numéro(s) sans ID de campagne`,
    campaignSummaryDescription: `Ces numéros pourraient ne pas pouvoir envoyer de SMS à moins qu'ils soient sans frais ou des numéros canadiens.`,
    backToList: `← Retour à la liste`,
    updating: `Mise à jour...`,
    updateButton: `Mettre à jour le groupe de messagerie`,
    noMembersWarning: `Ce groupe n'a aucun membre. Les messages des clients pourraient ne pas être lus.`,
  },
  createModal: {
    validationErrorTitle: `Erreur de validation`,
    validationErrorDescription: `Veuillez entrer un nom pour le groupe de messagerie`,
    title: `Créer un groupe de messagerie`,
    nameLabel: `Nom du groupe`,
    namePlaceholder: `Entrez le nom du groupe`,
    primarySmsLabel: `Numéro SMS principal`,
    primarySmsPlaceholder: `Sélectionnez un numéro`,
    primarySmsRequired: `Veuillez sélectionner un numéro SMS principal`,
    cancel: `Annuler`,
    creating: `Création...`,
    createButton: `Créer le groupe`,
  },
  members: {
    groupMembersTitle: `Membres du groupe`,
    emptyGroup: `Aucun membre dans ce groupe pour le moment.`,
    columnName: `Nom`,
    columnExtension: `Poste`,
    columnAdded: `Ajouté`,
    availableMembersTitle: `Membres disponibles`,
    emptyAvailable: `Aucun membre disponible à ajouter.`,
    removeMemberAria: `Supprimer le membre`,
    addMemberAria: `Ajouter un membre`,
    searchPlaceholder: `Rechercher par nom ou poste...`,
    noSearchResults: `Aucun membre ne correspond à votre recherche.`,
  },
  smsModal: {
    validationErrorTitle: `Erreur de validation`,
    validationErrorDescription: `Veuillez sélectionner un numéro SMS`,
    title: `Numéros SMS associés`,
    label: `Numéros SMS associés`,
    loading: `Chargement...`,
    selectPlaceholder: `Sélectionnez un numéro`,
    submitting: `Envoi...`,
    submit: `Envoyer`,
    close: `Fermer`,
  },
  pagination: {
    resultsPerPage: `Résultats par page :`,
    previousPage: `Page précédente`,
    nextPage: `Page suivante`,
    jumpToPage: `Aller à la page {{page}}`,
    all: `Tous`,
  },
} satisfies MessagingLocale
